import { Button, FormControl, FormLabel, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, SimpleGrid, Stack, Text, useToast } from "@chakra-ui/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { adminCreateMedicine } from "../../../api";
import { colors } from "../../../styles";

interface CreateMedModalProps {
    isOpen : boolean;
    onClose : () => void;
    page: number;
    size: number;
    representativeCode: string;
    standardCode: string;
    seqNo: string;
    nameKor: string;
    nameEng: string;
    category: string;
    maker: string;
    seller: string;
    packageUnit: string;
    ingredientInfo: string;
    packImage: string;
    pillImage: string;
    ingredientCode: string;
    atcCode: string;
    classification: string;
    basePrice: string;
    efficacy: string;
    searchKeyword: string;
}

export default function CreateMedModal(props : CreateMedModalProps) {

    interface ICreateMedForm {
        category?:string;           
        classification?:string;     
        nameEng?:string;            
        nameKor?:string;            
        ingredientKor?:string;      
        ingredientEng?:string;      
        ingredientInfo?:string;     
        quantity?:string;           
        unit?:string;               
        standard?:string;           
        usage?:string;              
        efficacy?:string;           
        sideEffect?:string;         
        usagePrecaution?:string;    
        storagePrecaution?:string;  
        validityPeriod?:string;     
        maker?:string;             
        seller?:string;             
        dosageRoute?:string;        
        interaction?:string;        
        insurancePrice?:string;     
        basePrice?:string;          
        unitPrice?:string;          
        pillImage?:string;          
        packImage?:string;          
        packageForm?:string;        
        packageQuantity?:string;      
        packageType?:string;        
        packageUnit?:string;        
        coverage?:string;        
        seqNo?:string;        
        representativeCode?:string;        
        standardCode?:string;        
        atcCode?:string;        
        ingredientCode?:string;        
        insuaranceCode?:string;        
        priceStartDate?:string;        
        cancelDate?:string;        
        permissionDate?:string;        
    }

    const { register, handleSubmit } = useForm();

    const medicineFields = [
        { label: "표준코드", name: "standardCode" },
        { label: "한글명", name: "nameKor" },
        // { label: "카테고리", name: "category" },
        // { label: "분류명", name: "classification" },
        // { label: "영문명", name: "nameEng" },
        // { label: "성분 한글명", name: "ingredientKor" },
        // { label: "성분 영문명", name: "ingredientEng" },
        // { label: "성분 정보", name: "ingredientInfo" },
        // { label: "용량", name: "quantity" },
        // { label: "단위", name: "unit" },
        // { label: "규격", name: "standard" },
        // { label: "용법", name: "usage" },
        // { label: "효능", name: "efficacy" },
        // { label: "부작용", name: "sideEffect" },
        // { label: "사용상 주의", name: "usagePrecaution" },
        // { label: "보관상 주의", name: "storagePrecaution" },
        // { label: "유효기간", name: "validityPeriod" },
        // { label: "제조사", name: "maker" },
        // { label: "판매사", name: "seller" },
        // { label: "투여 경로", name: "dosageRoute" },
        // { label: "상호작용", name: "interaction" },
        // { label: "보험 약가", name: "insurancePrice" },
        // { label: "기준 약가", name: "basePrice" },
        // { label: "수량 별 할인가", name: "unitPrice" },
        // { label: "낱알 이미지", name: "pillImage" },
        // { label: "포장 이미지", name: "packImage" },
        // { label: "포장 형태", name: "packageForm" },
        // { label: "포장 수량", name: "packageQuantity" },
        // { label: "포장 타입", name: "packageType" },
        // { label: "포장 단위", name: "packageUnit" },
        // { label: "급여, 비급여", name: "coverage" },
        { label: "품목일련번호", name: "seqNo" },
        // { label: "대표코드", name: "representativeCode" },
        // { label: "ATC 코드", name: "atcCode" },
        // { label: "성분코드", name: "ingredientCode" },
        // { label: "보험 코드", name: "insuaranceCode" },
        // { label: "약가적용일", name: "priceStartDate" },
        // { label: "취하 일자", name: "cancelDate" },
        // { label: "허가 일자", name: "permissionDate" },
    ]

    const onSubmit = async (data: ICreateMedForm) => {

        // "" 값인 모든 필드를 null로 변환해서 data를 생성

        Object.keys(data).forEach((key) => {
            if (data[key as keyof ICreateMedForm] === "") {
                data[key as keyof ICreateMedForm] = undefined;
            }
        });
        
        await createMedicineMutation.mutateAsync({ medicine: data });
    }

    /* query client */

    const queryClient = useQueryClient();
    
    /* toast */

    const toast = useToast();

    /* create medicine */

    const createMedicineMutation = useMutation({
        mutationFn: adminCreateMedicine,
        onSuccess: () => {
            toast({
                title: "약품 등록에 성공했습니다.",
                status: "success",
                position: "top",
                duration: 2000,
                isClosable: true,
            });
            props.onClose();
            queryClient.invalidateQueries({ queryKey: ['adminGetMedicines', { 
                                                                                page: props.page, 
                                                                                size: props.size, 
                                                                                representativeCode: props.representativeCode,
                                                                                standardCode: props.standardCode,
                                                                                seqNo: props.seqNo,
                                                                                nameKor: props.nameKor,
                                                                                nameEng: props.nameEng,
                                                                                category: props.category,
                                                                                maker: props.maker,
                                                                                seller: props.seller, 
                                                                                packageUnit: props.packageUnit, 
                                                                                ingredientInfo: props.ingredientInfo, 
                                                                                packImage: props.packImage, 
                                                                                pillImage: props.pillImage, 
                                                                                ingredientCode: props.ingredientCode, 
                                                                                atcCode: props.atcCode, 
                                                                                classification: props.classification, 
                                                                                basePrice: props.basePrice, 
                                                                                efficacy: props.efficacy, 
                                                                                searchKeyword: props.searchKeyword 
                                                                            }] });
        },
        onError: (error) => {
            console.error(error);
            toast({
                title: "약품 등록에 실패했습니다.",
                status: "error",
                position: "top",
                duration: 2000,
                isClosable: true,
            });
        },
    });

    return (
        <Modal motionPreset="slideInBottom" size={"4xl"} isOpen={props.isOpen} onClose={props.onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    <Text color={colors.blue} fontSize="lg" fontWeight="bold">약품 등록</Text>
                    <ModalCloseButton />
                </ModalHeader>
                <ModalBody paddingTop={5}>
                    <SimpleGrid columns={3} spacing={3}>
                        {medicineFields.map((field) => (
                            <FormControl key={field.name}>
                                <FormLabel fontSize="xs" color={colors.blue}>
                                    {field.name}
                                </FormLabel>
                                <Input 
                                    {...register(field.name, { required: field.name === "standardCode" ? true : false })}
                                    type="text" 
                                    placeholder={field.label}
                                />
                            </FormControl>
                        ))}
                    </SimpleGrid>
                    <Stack marginTop={5} width={"100%"} padding={3}>
                        <Button 
                            onClick={handleSubmit(onSubmit)}
                            isLoading={createMedicineMutation.isPending}
                            width={"100%"}
                            backgroundColor={colors.blue}
                            color={colors.white}
                            borderRadius={10}
                            _hover={{ bg: colors.blue }}
                            boxShadow="sm"
                        >
                            등록
                        </Button>
                    </Stack>
                </ModalBody>
            </ModalContent>
        </Modal>    
    )
}